<div class="primary-bg">
  <app-landing-header></app-landing-header>
  <div class="about-img">
    <div class="lg-container">
      <div class="row">
        <div class="m-auto">
          <h1 class="brand-name">
            ABOUT <span class="text-blue">EZYAGRIC</span>
          </h1>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col  px-5 my-5 text-center about-info">
        <h1 class="px-5 my-5">
          The number one solution for all your profiling needs
        </h1>
        <p class="pt-5 p-line-height">
          EzyAgric is supplemented by the e-VAM (Electronic Village Agent Model)
          a service delivery model in which community-based service providers
          equipped with smartphones who readily deliver services on demand by
          the farmers.
        </p>
      </div>
    </div>
  </div>

  <div class="white-bg py-5">
    <div class="lg-container">
      <div class="row">
        <div class="col text-right py-5 margin-more">
          <p>
            Through produce market,<br />Sell and buy produce from farmers and
            traders
          </p>
          <p class="my-4">
            Diagnose disease promptly on your farm, <br />Watch agronomic videos
            and interact with our experienced agronomist
          </p>
          <p>
            Track your income and expenditure for informed decision making app
            and get season performance analysis in real time
          </p>
        </div>

        <div class="col text-center">
          <h3>Ezyagric Mobile app</h3>
          <img src="../../../assets/images/mobile.png" />
        </div>

        <div class="col py-5 margin-more">
          <p>
            Digitize your bio and production data anytime and get accurate GPS
            mappingfor your garden
          </p>
          <p class="my-5">
            Order for soil testing, buy genuine inputs and get agriculture
            insurance
          </p>
          <p>
            Order for soil testing, buy genuine inputs and get agriculture
            insurance
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="row white-bg px-5 ">
    <div class="col text-center py-3">
      &copy; {{ dateService.year }} Copyright Akorion Company Ltd
    </div>
  </div>
</div>
